import CustomerPriceIncrease from "./CustomerPriceIncrease";
import DiscountMaster from "./DiscountMaster";
import GermanVat from "./GermanVat";
import PriceIncrease from "./PriceIncrease";
import VendorPriceIncrease from "./VendorPriceIncrease";
import TransferDiscount from "./TransferDiscount";

const DiscountMasterConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/discountMaster',
            element: <DiscountMaster />,
        },
         {
            path: '/transferDiscount',
            element: <TransferDiscount />,
        },
         {
            path: '/germanVat',
            element: <GermanVat />,
        },
        {
            path: '/priceIncrease',
            element: <PriceIncrease />,
        },
        {
            path: '/customerPriceIncrease',
            element: <CustomerPriceIncrease />,
        },
        {
            path: '/vendorPriceIncrease',
            element: <VendorPriceIncrease />,
        },
    ],
};

export default DiscountMasterConfig;
